import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"width":"80%"} }

import { reactive, onMounted } from 'vue'
  import api from '@/api/index'
  import { ElMessage, ElLoading } from 'element-plus'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Store',
  setup(__props) {

  const form = reactive({
    platform_code:10016,
    seller_id:"",
  })
  const baseData:any = reactive({
    sellerList:[],
  })
  
  const getSellerList = () => {
    const loading = ElLoading.service({lock: true})
    api.lingxingApi.getSellerList({platform_code:form.platform_code}).then((res:any)=>{
      if(res.code==200){
        baseData.sellerList = res.data.list
        form.seller_id = res.data.seller_id
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const save =  () => { 
    const loading = ElLoading.service({lock: true})
    api.lingxingApi.save_store({seller_id: form.seller_id}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getSellerList()
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  
  onMounted(() => {
    getSellerList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_breadcrumb, {
          class: "breadcrumb",
          separator: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode("店铺设置")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "180px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_divider, { "content-position": "left" }, {
                default: _withCtx(() => [
                  _createTextVNode("店铺")
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: form.seller_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.seller_id) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.sellerList, (item1) => {
                        return (_openBlock(), _createBlock(_component_el_radio, {
                          key: item1.store_id,
                          label: item1.store_id,
                          value: item1.store_id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item1.store_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "success",
                  onClick: save
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})